'use client'

import parseHtml, { domToReact } from 'html-react-parser';

// 是 h2, h3 且有 id 才會被放入目錄中
const parseDirectoryOptions = {
  replace: ({ name, attribs, children }) => {
    if (["h2", "h3"].includes(name) && attribs.id) {
      const handleClick = () => {
        document.getElementById(attribs.id).scrollIntoView({ block: "center", inline: "nearest", behavior: "smooth" })
      }
      return (
        <li 
          className={`${name === "h2" ? 'ml-0' : 'ml-6'} list-[square] leading-8 tracking-wider font-medium text-primary cursor-pointer hover:text-secondary`}
          onClick={handleClick}
        >
          {domToReact(children)}
        </li>
      )
    } else {
      return <></>
    }
  }
};

function Directory({ content }) {
  const directoryList = parseHtml(content, parseDirectoryOptions);

  if (directoryList.some(ele => ele.type === "li")) {
    return (
      <div className=''>
        <h3 className='mx-2 pl-2 text-2xl font-bold border-l-4 border-primary'>目錄</h3>
        <ul className='p-5'>
          {directoryList}
        </ul>
      </div>
    )
  }

  return null;
};

export default Directory;